import { defineComponent as _defineComponent } from 'vue';
import { cn } from '../../primitives/utils';
import { useSidebar } from "./utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SidebarRail',
    props: {
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const { toggleSidebar } = useSidebar();
        const __returned__ = { props, toggleSidebar, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
